import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SocialMediaDeleteService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchSocialMediaDelete = createAsyncThunk(
    'sliderGet/fetchSocialMediaDelete',
    async ({ id }) => {
        const response = await SocialMediaDeleteService(id)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const socialMediaDeleteSlice = createSlice({
    name: 'socialMediaDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSocialMediaDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSocialMediaDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSocialMediaDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default socialMediaDeleteSlice.reducer;
